import React from "react";
import { styled } from "@mui/material/styles";
import { Link, LinkProps } from "@mui/material";
import FontIcon, { ODL_ICONS } from "@odl/core/components/DataDisplay/FontIcon";
import { css } from "@emotion/react";
import FlexBox from "components/FlexBox/FlexBox";

type Props = {
  displayValue: string;
  iconName: typeof ODL_ICONS[keyof typeof ODL_ICONS];
  linkUrl: string;
  variant?: LinkProps["variant"];
};

const InfoLink: React.FC<Props> = ({ displayValue, iconName, linkUrl, variant }) => {
  if (!displayValue) {
    return null;
  }

  return (
    <StyledContainer data-testid="InfoLink">
      <FlexBox alignItems={"center"}>
        <FontIcon name={iconName} />
      </FlexBox>
      <StyledLink variant={variant} href={linkUrl} target={"_blank"} rel="noopener">
        {displayValue}
      </StyledLink>
    </StyledContainer>
  );
};

const StyledContainer = styled("div")(
  ({ theme }) => css`
    line-height: 25px;
    display: flex;
    ${theme.mixins.flexGap("8px")}
    font-size: 14px;
    color: ${theme.palette.text.secondary};
  `
);
const StyledLink = styled(Link)(
  ({ theme }) => css`
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  `
);
export default InfoLink;
